import React, { memo } from 'react';
import styled from 'styled-components/macro';

const Wrapper = styled.div`
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    .card .header {
        display: flex;
        align-items: center;
    }
    .header .img {
        height: 75px;
        width: 75px;
        background: #656871;
        border-radius: 50%;
        position: relative;
        overflow: hidden;
    }
    .header .details {
        margin-left: 0;
    }
    .details span {
        display: block;
        background: #656871;
        border-radius: 10px;
        overflow: hidden;
        position: relative;
    }
    .details .name {
        height: 20px;
        width: 150px;
    }
    .details .about {
        height: 15px;
        width: 250px;
        margin-top: 10px;
    }
    .card .description {
        margin: 25px 0;
    }
    .description .line {
        background: #656871;
        border-radius: 10px;
        height: 13px;
        margin: 10px 0;
        overflow: hidden;
        position: relative;
    }
    .description .line-1 {
        width: calc(100% - 15%);
    }
    .description .line-3 {
        width: calc(100% - 40%);
    }
    .card .btns {
        display: flex;
    }
    .card .btns .btn {
        height: 45px;
        width: 100%;
        background: #656871;
        border-radius: 25px;
        position: relative;
        overflow: hidden;
    }
    .btns .btn-1 {
        margin-right: 8px;
    }
    .btns .btn-2 {
        margin-left: 8px;
    }
    .header .img::before,
    .details span::before,
    .description .line::before,
    .btns .btn::before {
        position: absolute;
        content: '';
        height: 100%;
        width: 100%;
        background-image: linear-gradient(to right, #656871 0%, #888b94 20%, #656871 40%, #656871 100%);
        background-repeat: no-repeat;
        background-size: 450px 400px;
        animation: shimmer 1s linear infinite;
    }
    .header .img::before {
        background-size: 650px 600px;
    }
    .details span::before {
        animation-delay: 0.2s;
    }
    .btns .btn-2::before {
        animation-delay: 0.2s;
    }
    @keyframes shimmer {
        0% {
            background-position: -450px 0;
        }
        100% {
            background-position: 450px 0;
        }
    }

    .b-btn {
        color: white;
        position: absolute;
        bottom: 3rem;
        text-decoration: none;
    }
    .b-btn-2 {
        text-decoration: none;
        color: white;
        position: absolute;
        bottom: 1rem;
    }
    .b-btn-2 i {
        color: orange;
    }
    .b-btn:hover,
    .b-btn-2:hover {
        text-decoration: underline;
    }
    .b-btn i {
        color: yellow;
    }
`;

const LazyLoadView = () => {
    return (
        <Wrapper>
            <div className="card">
                <div className="header">
                    <div className="details">
                        <span className="name" />
                        <span className="about" />
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};

LazyLoadView.propTypes = {};

export default memo(LazyLoadView);
